import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">
            内容分类
          </span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-800">
            探索不同内容类型
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            根据您的偏好浏览不同类型的欧美无码平台，找到最适合您的观看方式
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-800">{cat.name}</h3>
                    <span className="text-xs text-foreground-400">{cat.count} 个平台</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}